/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	// modules
	
	    /**
	     * header-menu
	     */
	    var menu = $('.l-nav-global');
	    var menuBtn = $('.js-hamburger, #menu-close-btn');
	    var body = $(document.body);
	    var menuWidth = menu.outerWidth();
	    var pageContent = $('.l-main');
	
	    pageContent.on('click', function(){
	        if(body.hasClass('is-open')){
	            menu.animate({'left' : -menuWidth }, 100);
	            body.animate({'left' : 0 }, 100);
	            body.removeClass('open');
	        }
	    });
	    
	    menuBtn.on('click', function(){
	        body.toggleClass('is-open');
	        if(body.hasClass('is-open')){
	            body.animate({'left' : menuWidth }, 300);
	            menu.animate({'left' : 0 }, 300);
	        } else {
	            menu.animate({'left' : -menuWidth }, 300);
	            body.animate({'left' : 0 }, 300);
	        }
	    });
	
	    $('.l-carousel-main-items').slick({
	    //    centerMode: true,
	    //    variableWidth: true,
	        
	        slidesToShow: 1,
	        arrows: false,
	        fade: true,
	        cssEase: 'linear',
	        autoplay: true,
	        autoplaySpeed: 5000,
	        responsive: [{
	            breakpoint: 678,
	            settings: {
	                variableWidth: false,
	
	                centerMode: false,
	                slidesToShow: 1
	            }
	        }]
	    });
	
	    $('.l-carousel-footer').slick({
	        slidesToShow: 3,
	        arrows: true,
	        responsive: [{
	            breakpoint: 678,
	            settings: {
	                slidesToShow: 1
	            }
	        }]
	    });
	
	    $('.l-carousel-profile').slick({
	        slidesToShow: 3,
	        arrows: true,
	        responsive: [{
	            breakpoint: 678,
	            settings: {
	                slidesToShow: 1
	            }
	        }]
	    });
	
	   if ($('.datepicker2').length) {
	    $('.datepicker2').datepicker({
	            dateFormat : "yy/mm/dd"
	            ,dayNamesMin: ['日', '月', '火', '水', '木', '金', '土']
	            ,showOn: "button"
	            ,buttonImageOnly : true
	            ,buttonImage : "https://www.softel.co.jp/blogs/jquery/wp/wp-content/uploads/2012/01/calendar.gif"
	            ,beforeShow : function(input,inst){
	                //開く前に日付を上書き
	                var year = $(this).parent().find(".year").val();
	                var month = $(this).parent().find(".month").val();
	                var date = $(this).parent().find(".date").val();
	                $(this).datepicker( "setDate" , year + "/" + month + "/" + date)
	            },
	            onSelect: function(dateText, inst){
	                //カレンダー確定時にフォームに反映
	                var dates = dateText.split('/');
	                $(this).parent().find(".year").val(dates[0]);
	                $(this).parent().find(".month").val(dates[1]);
	                $(this).parent().find(".date").val(dates[2]);
	            }
	        });
	    }
	
	$('.l-photo-slider').slick({
	    arrows: false,
	    autoplay: true,
	    infinite: true,
	    /* ポイントここから～ */
	    autoplaySpeed: 0,
	    cssEase: 'linear',
	    speed: 10000,
	    /* ～ここまで */
	    slidesToShow: 3,
	    slidesToScroll: 1,
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.min.js